/**
 * THEME JSON CONFIG CSS VARS
 * The following default component scss variables can be overwritten via theme configuration per brand.
 * If you need to add new one, please make sure to set a default value.
 * JSON Definition for Component with name "Example": testCssVar: "20px"
 * Resulting CSS var: $example-test-css-var: 20px;
 */

$navigation-meta-font-size: 14px !default;
$navigation-meta-letter-spacing: normal !default;
$navigation-main-focus-border-width: 2px !default;
$navigation-main-border-style: solid !default;
$navigation-focus-border-color: #d3d3d3 !default;
$navigation-main-border-color-focus-visible: transparent !default;

/* END THEME JSON CONFIG CSS VARS ******************************************************* */

:host {
  display: block;
}

a {
  position: relative;
  height: 100%;
  font-family: $font-family-base;
  font-size: $navigation-meta-font-size;
  letter-spacing: $navigation-meta-letter-spacing;
  line-height: 18px;
  text-align: center;
  padding: 14px 8px 14px 8px;
  color: $navigation-meta-link-font-color;
  background-color: $navigation-meta-link-bg-color;
  text-decoration: none;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  cursor: pointer;

  .#{$prefix}text-wrapper {
    padding: 2px 4px;
  }

  &::after {
    content: "";
    position: absolute;
    left: 0;
    bottom: -2px;
    width: 100%;
    height: 2px;
    background-color: $navigation-meta-link-border-color;
  }

  &:hover {
    color: $navigation-meta-link-font-color-hover;
    background-color: $navigation-meta-link-bg-color-hover;

    &::after {
      background-color: $navigation-meta-link-border-color-hover;
    }
  }

  &:focus {
    color: $navigation-meta-link-font-color-focus;
    background-color: $navigation-meta-link-bg-color-focus;
    outline: none;

    &::after {
      background-color: $navigation-meta-link-border-color-focus;
    }
  }

  &:focus-visible {
    .#{$prefix}text-wrapper {
      outline: $navigation-main-focus-border-width $navigation-main-border-style $navigation-focus-border-color;
      border-radius: 4px;
    }

    &::after {
      background-color: $navigation-main-border-color-focus-visible;
    }
  }

  &.#{$prefix}current {
    color: $navigation-meta-link-font-color-current;
    background-color: $navigation-meta-link-bg-color-current;

    &::after {
      background-color: $navigation-meta-link-border-color-current;
    }

    &:hover {
      color: $navigation-meta-link-font-color-current-hover;
      background-color: $navigation-meta-link-bg-color-current-hover;

      &::after {
        background-color: $navigation-meta-link-border-color-current-hover;
      }
    }

    &:focus {
      color: $navigation-meta-link-font-color-current-focus;
      background-color: $navigation-meta-link-bg-color-current-focus;
      outline: none;

      &::after {
        background-color: $navigation-meta-link-border-color-current-focus;
      }
    }
  }
}
